import { Link } from "react-router-dom";
import { Brand } from "@/components/Brand";
import { ArrowLeft } from "lucide-react";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-[#FAFAF7] text-[#0A0A0F] text-left">
      <header className="border-b border-[#EAEAE3] bg-white sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between">
          <Brand />
          <Link to="/" className="flex items-center gap-2 text-sm text-[#5C5C66] hover:text-[#0A0A0F] transition-colors">
            <ArrowLeft className="h-4 w-4" /> Back to Home
          </Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-12 lg:py-20">
        <div className="label-mono mb-4 text-[#002FA7]">— Legal Agreement</div>
        <h1 className="font-display text-4xl lg:text-5xl font-black tracking-tight mb-8">Privacy Policy</h1>
        <p className="text-sm text-[#5C5C66] mb-12">Last updated: June 9, 2026</p>
        
        <div className="prose prose-slate max-w-none space-y-8 text-sm text-[#5C5C66] leading-relaxed">
          <section className="space-y-3">
            <h2 className="font-display text-xl font-bold text-[#0A0A0F]">1. Information We Collect</h2>
            <p>
              We collect information you provide directly to us when creating an account, such as your name, email address, company details, and billing information. We also collect the domain information and search terms you input into our scraper tools.
            </p>
          </section>
          
          <section className="space-y-3">
            <h2 className="font-display text-xl font-bold text-[#0A0A0F]">2. How We Use Your Information</h2>
            <p>
              We use the information we collect to operate, maintain, and provide the features of the Service; to process payments; to communicate with you about your account; and to enforce our Terms of Service.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="font-display text-xl font-bold text-[#0A0A0F]">3. Data Sharing and Disclosure</h2>
            <p>
              We do not sell your personal data. We share your information only with service providers who perform services on our behalf (e.g. Stripe for payment processing, Brevo for email delivery) and as required by law to protect our rights.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="font-display text-xl font-bold text-[#0A0A0F]">4. Data Retention and Security</h2>
            <p>
              We take reasonable administrative, physical, and electronic measures designed to protect your information from unauthorized access, use, or disclosure. We retain your information for as long as your account is active or as needed to provide you the Service.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="font-display text-xl font-bold text-[#0A0A0F]">5. Your Choices and Rights</h2>
            <p>
              You can update or delete your account information at any time from your settings page. You may also contact us to request the complete deletion of your data from our active systems.
            </p>
          </section>
        </div>
      </main>
      <footer className="border-t border-[#EAEAE3] py-8 text-center text-xs text-[#9A9AA3] bg-white">
        © 2026 LeadsB2B. All rights reserved.
      </footer>
    </div>
  );
}
